// ui/Sheet — the phone counterpart of ui/Modal (Design Standard v1: sheets, not
// modals, at 390). Bottom-anchored, scrim closes it, Escape closes it; the footer
// holds the primary action at thumb reach. Portals into #modal-root like Modal.
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import Button from './button';
import './ds.css';

export default function Sheet({ open, onClose, title, footer = null, children, className = '' }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  const root = typeof document !== 'undefined' ? document.getElementById('modal-root') || document.body : null;
  if (!open || !root) return null;
  return ReactDOM.createPortal(
    <>
      <div className="ds-sheet__scrim" onClick={onClose} />
      <section className={`ds-sheet ${className}`} role="dialog" aria-modal="true" aria-label={title}>
        <div className="ds-sheet__grip" aria-hidden="true" />
        <div className="ds-sheet__head">
          <h2 className="ds-sheet__title">{title}</h2>
          <Button variant="ghost" iconOnly aria-label="Close" onClick={onClose}><X size={18} /></Button>
        </div>
        <div className="ds-sheet__body">{children}</div>
        {footer ? <div className="ds-sheet__foot">{footer}</div> : null}
      </section>
    </>,
    root
  );
}
